/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuWorkerDocsCheckSvuCrossKrajPartialUpdateRequest = {} | null | undefined;
export type SvuWorkerDocsCheckSvuCrossKrajPartialUpdateResponse = any;

export type SvuWorkerDocsCheckSvuCrossKrajPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/check_svu_cross_kraj/
 *
 * ```yaml
 * operationId: svu_worker_docs_check_svu_cross_kraj_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsCheckSvuCrossKrajPartialUpdateOperation = ({
  id,
  ...rest
}: SvuWorkerDocsCheckSvuCrossKrajPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_worker_docs/${id}/check_svu_cross_kraj/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_worker_docs/{id}/check_svu_cross_kraj/' };
  };

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/check_svu_cross_kraj/
 *
 * ```yaml
 * operationId: svu_worker_docs_check_svu_cross_kraj_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsCheckSvuCrossKrajPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuWorkerDocsCheckSvuCrossKrajPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuWorkerDocsCheckSvuCrossKrajPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
